// extracted by mini-css-extract-plugin
export default {"main":"Manage_main__ULJ3d","search":"Manage_search__mAj7U","assignment":"Manage_assignment__PLIDU"};